// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"609":"d3ac292a","928":"9e8e9a2a"}[chunkId] + ".chunk.js";
};